import Headroom from '../plugins/HeadroomPlugin.js';

export default function initHeadroom() {
	jQuery('#header').each(function(i, header) {
		const headroom = new Headroom(this, {
			offset: {
				up: 120,
				down: 120
			},
			onPin : function() {
				jQuery(header).trigger('pin');
			},
			onUnpin : function() {
				jQuery(header).trigger('unpin');
				hideDrops();
			},
			onTop: function () {
				jQuery('.fixed-btn').hide();
			},
			onNotTop: function () {
				jQuery('.fixed-btn').show();
			}
		});
		const resizeObserver = new ResizeObserver(resizeHandler);

		// initialise
		headroom.init();

		jQuery(header).data('headroom', headroom);

		function resizeHandler() {
			document.documentElement.style.setProperty('--header-height', jQuery(header).outerHeight() + 'px');
		}

		function hideDrops() {
			if (bootstrap && bootstrap.Dropdown && !jQuery('body').hasClass('nav-active')) {
				jQuery('#header .dropdown-toggle.show').each((i, el) => {
					bootstrap.Dropdown.getOrCreateInstance(el).hide();
				});
			}
		}

		resizeObserver.observe(document.body);
	});
}
